var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.56969 20.0033C1.37509 20.0033 1.18484 19.9461 1.02302 19.8387C0.861197 19.7314 0.73507 19.5789 0.660593 19.4004C0.586115 19.2219 0.566632 19.0255 0.604608 18.836C0.642583 18.6465 0.736312 18.4724 0.873938 18.3358L19.0548 0.286112C19.2394 0.102917 19.4896 0 19.7506 0C20.0116 0 20.2618 0.102917 20.4464 0.286112C20.6309 0.469306 20.7345 0.71777 20.7345 0.976846C20.7345 1.23592 20.6309 1.48439 20.4464 1.66758L2.26545 19.7173C2.17416 19.8081 2.06571 19.8801 1.94631 19.9292C1.82691 19.9783 1.69892 20.0035 1.56969 20.0033Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7505 20.0033C19.6213 20.0035 19.4933 19.9783 19.3739 19.9292C19.2545 19.8801 19.1461 19.8081 19.0548 19.7173L0.873884 1.66758C0.689359 1.48439 0.585693 1.23592 0.585693 0.976846C0.585693 0.71777 0.689359 0.469306 0.873884 0.286112C1.05841 0.102917 1.30868 0 1.56964 0C1.8306 0 2.08087 0.102917 2.26539 0.286112L20.4463 18.3358C20.5839 18.4724 20.6777 18.6465 20.7156 18.836C20.7536 19.0255 20.7341 19.2219 20.6596 19.4004C20.5852 19.5789 20.459 19.7314 20.2972 19.8387C20.1354 19.9461 19.9452 20.0033 19.7505 20.0033V20.0033Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.0f1ad1973e4af484d5d61d6b1c8bea39.svg";
export { ForwardRef as ReactComponent };